const pathToArrayPath = (path: string) => {
  if (path == null || path === '') return [];
  return path.split('.');
};

const resolveArrayPath: any = (object: any, path: any) => {
  const [property, ...subPath] = path;
  if (object == null || property == null) {
    return undefined;
  }
  return subPath.length === 0
    ? object[property]
    : resolveArrayPath(object[property], subPath);
};

export default (object: any, path: any) =>
  resolveArrayPath(object, pathToArrayPath(path));
